// @flow

export const REMOVE_POPUP = 'REMOVE_POPUP'
export const CREATE_POPUP = 'CREATE_POPUP'
export const REMOVE_QUESTION = 'REMOVE_QUESTION'
export const DONT_REMOVE_GROUP = 'DONT_REMOVE_GROUP'

export const DEFAULT_AVATAR =
  'https://files.idwell.com/sys/thumbnail/170_default_avatar.png'
